import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {ContentSurface, Prose} from "../components/ContentPage";
import DataDeletion from "../legal/DataDeletion";

/**
 * Public, pre-rendered Data Deletion Instructions page (ui#185).
 *
 * Meta's App Review requires a publicly reachable "Data Deletion Instructions URL" before it will
 * approve public Facebook login, so this page must stay crawlable and must NOT sit behind auth —
 * the reviewer opens it signed out. Built exactly like the other legal routes ({@link ./PrivacyRoute}).
 */
export function Component() {
	const {resourceTitles, seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.dataDeletion.title}
				description={seo.dataDeletion.description}
				path="/data-deletion"
			/>
			<ContentSurface>
				<Prose>
					<h1>{resourceTitles.dataDeletion}</h1>
					<DataDeletion/>
				</Prose>
			</ContentSurface>
		</>
	);
}
